import China from "assets/geojson/China.json";
import hkh from "assets/geojson/hkh.json";
import Afghanistan from "assets/geojson/Afghanistan.json";
import Nepal from "assets/geojson/Nepal.json";
import Pakistan from "assets/geojson/Pakistan.json";
import Myanmar from "assets/geojson/Myanmar.json";
import India from "assets/geojson/India.json";
import Bhutan from "assets/geojson/Bhutan.json";
import Bangladesh from "assets/geojson/Bangladesh.json";
import Tiles from "assets/geojson/tiles.json";

// 注意！geojson的投影必须是EPSG:3857
const geojsons = [
  { name: "HKH Region", json: hkh },
  { name: "China", json: China },
  { name: "Afghanistan", json: Afghanistan },
  { name: "Nepal", json: Nepal },
  { name: "Bhutan", json: Bhutan },
  { name: "Bangladesh", json: Bangladesh },
  { name: "Pakistan", json: Pakistan },
  { name: "Myanmar", json: Myanmar },
  { name: "India", json: India },
  { name: "Tiles", json: Tiles },
];

const Region = ["HKH Region"];
const Countries = [
  "China",
  "Afghanistan",
  "Nepal",
  "Bhutan",
  "Pakistan",
  "Myanmar",
  "India",
  "Bangladesh",
];
export { geojsons, Region, Countries };
